import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import { PASSPORT_REMINDER, PASSPORT_RENEW, PASSPORT_ACK_WORDING } from '../../utils/travellerValidation';

/** Flight 380 booking reminder: six-month passport validity notice + required (unticked) acknowledgement. */
export const PassportValidityNotice = ({ checked, onChange, blocked = false, blockedReason = '', testIdPrefix = 'passport' }) => (
  <div className="rounded-xl border-2 border-amber-300 bg-amber-50 p-4 space-y-3" data-testid={`${testIdPrefix}-validity-notice`}>
    <div className="flex items-start gap-3">
      <ShieldAlert className="h-5 w-5 text-amber-700 mt-0.5 flex-shrink-0" />
      <div className="space-y-1">
        <div className="font-bold text-amber-900">Passport check — all travellers (adults, children and infants)</div>
        <p className="text-sm text-amber-900" data-testid={`${testIdPrefix}-reminder`}>{PASSPORT_REMINDER}</p>
        <p className="text-sm font-semibold text-amber-900" data-testid={`${testIdPrefix}-renew`}>{PASSPORT_RENEW}</p>
      </div>
    </div>
    {blocked && (
      <div className="rounded-lg bg-rose-100 border border-rose-300 text-rose-900 text-sm p-3" data-testid={`${testIdPrefix}-blocked`}>
        {blockedReason || 'A passport expiry you entered leaves less than six months\u2019 validity on the date of travel. Please renew it before booking.'}
      </div>
    )}
    <label className={`flex items-start gap-3 ${blocked ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}>
      <Checkbox checked={!!checked && !blocked} disabled={blocked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid={`${testIdPrefix}-ack-checkbox`} />
      <span className="text-sm text-slate-800">{PASSPORT_ACK_WORDING}</span>
    </label>
  </div>
);
